const apiEndpoint =
  process.env.API_ENDPOINT || 'https://gw-staging.ruangguru.com';
const clientId = process.env.CLIENT_ID || '729QGoN41A';
const clientSecret = process.env.CLIENT_SECRET || 'ekh6PbuuO8swo2h5ajYJ';
const country = process.env.COUNTRY || 'id';
const oAuthClientID = 'rg-order-cms';

module.exports = {
  proxyEndpoint: process.env.PROXY_ENDPOINT || '/', // MANDATORY
  appGroup: 'rg-admin',
  apiEndpoint: apiEndpoint, // MANDATORY
  clientId: clientId,
  clientSecret: clientSecret,
  s3Endpoint: 'https://s3-ap-southeast-1.amazonaws.com',
  country: country,
  maxInstallment: process.env.MAX_INSTALLMENT || 24,
  cancelOrder: process.env.CANCEL_ORDER || 0,
  rukerCompanySerial: process.env.RUKER_COMPANY_SERIAL || 'COMP0EELFNLF',
  trackerEndpoint:
    process.env.TRACKER_ENDPOINT || 'https://tracker-staging.ruangguru.com',
  accountUIURL:
    process.env.ACCOUNT_UI_URL || 'https://account-staging.ruangguru.com',
  authMiddleware: {
    host: apiEndpoint,
    clientID: clientId,
    clientSecret: clientSecret,
    country: country,
    oAuthClientID: oAuthClientID,
  },
  defaultHeaders: {
    'with-auth': true,
  },
  tenantProductTypeGroup: process.env.TENANT_PRODUCT_TYPE_GROUP || 'akademia,brainacademy,codeandrobochamps,englishacademy,mathchamps,roboguru,ruangguru,ruangguruprivate,ruangguruprivategts,ruangraya,ruker,schoters,schotersbusiness,skillacademy,studiokerja,altaschool',
  tenantProductTypeBalance: process.env.TENANT_PRODUCT_TYPE_BALANCE || 'ai,brainacademy,codeandrobochamps,englishacademy,ruangguru,ruangguruprivate,ruangguruprivategts,schoters,skillacademy,schotersbusiness,champions,ruanguji',
};
